import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import axios from 'axios'
import AppBar from '@material-ui/core/AppBar';
import L from 'leaflet';
import { Map, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';
import { PopupInfo, PopupVehicle } from './PopupMarker';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

import {BASE_URL_APIv5} from "../../constants/ActionTypes";

const configHeader = {
    headers: {
        'Content-Type': 'application/json'
    }
}

const markerIcon = new L.Icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    table: {
        minWidth: 1500,
    },
      flex: {
        flex: 1,
    },
    fullscreen: {
        width: '100%',
        padding: 0,
        margin: 0,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        width: '100%',
        overflowX: 'auto',
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

class ShareLocationJNT extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            currentHistory: {},
            zoom: 13,
            lat: -6.209932490589981,
            lon: 106.84255128476003,
            value: 0,
        };
        this.interval = null;
    };

    handleGetCurrentHistoryVehicle = async(imeiNo) => {
        const result = await axios.get(`${BASE_URL_APIv5}/current-location-vehicle-paxel/${imeiNo}`, configHeader)
                            .then(res => res)
                            .catch((error) => error.response)
        if (result.status === 200 && result.data.length > 0) {
            this.setState({currentHistory: result.data[0]})
            return result.data[0]
        } else {
            this.setState({currentHistory: {}})
            return {}
        }
    }

    async componentDidMount() {
        const { search } = this.props.location
        const params = new URLSearchParams(search);
        const imeiNo = params.get('imeiNo');

        this.handleGetCurrentHistoryVehicle(imeiNo)
        this.interval = setInterval(() => this.handleGetCurrentHistoryVehicle(imeiNo), 60000)
    };

    async componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleChange = (event, value) => {
      this.setState({ value });
    };

    handleChangeIndex = index => {
      this.setState({ value: index });
    };

    openPopup (marker) {
        if (marker && marker.leafletElement) {
            window.setTimeout(() => {
                marker.leafletElement.openPopup()
            })
        }
    }

    renderMap = () => {
        const {classes, theme} = this.props
        const {currentHistory, lat, lon, zoom} = this.state
        const position = currentHistory && currentHistory.coordinate ? currentHistory.coordinate : currentHistory.lat && currentHistory.lon ? [currentHistory.lat, currentHistory.lon] : [lat, lon]
        return(
            <Map center={position} zoom={zoom} scrollWheelZoom={true}>
                <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="Open Street Map">
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Open Street Map (Gray)">
                        <TileLayer url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"/>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Esri World Imagery">
                        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>
                    </LayersControl.BaseLayer>
                </LayersControl>
                <Marker position={position} icon={markerIcon} ref={this.openPopup}>
                    <Popup>
                        <div className="row">
                            <div className="col-md-12">
                                <div style={{paddingLeft: -20, paddingRight: -20, position: "relative"}}>
                                    <AppBar position="static" color="default">
                                        <Tabs
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            variant="fullWidth"
                                        >
                                            <Tab label="Vehicle" />
                                            <Tab label="Info" />
                                        </Tabs>
                                    </AppBar>
                                    <SwipeableViews
                                        axis={'x-reverse'}
                                        index={this.state.value}
                                        onChangeIndex={this.handleChangeIndex}
                                    >
                                        <TabContainer style={{paddingLeft: -30, paddingRight: -30}}>
                                            <div style={{paddingLeft: -30, paddingRight: -30}}> 
                                                <PopupVehicle 
                                                    data={currentHistory ? currentHistory : null}
                                                />
                                            </div>
                                        </TabContainer>
                                        <TabContainer style={{paddingLeft: -30, paddingRight: -30}}>
                                            <div style={{paddingLeft: -30, paddingRight: -30}}>
                                                <PopupInfo 
                                                    data={currentHistory ? currentHistory : null}
                                                />
                                            </div>
                                        </TabContainer>
                                    </SwipeableViews>
                                </div>
                            </div>
                        </div>
                    </Popup>
                </Marker>
            </Map>
        )
    }

    render() {
        const {classes} = this.props
        return (
            <div className={classes.fullscreen}>{this.renderMap()}</div>
        )
    }
}

export default withStyles(styles)(ShareLocationJNT);


// WEBPACK FOOTER //
// ./containers/ShareLocationJ&T/index.js